import { NonEmptyArray, TJsonQueryKeys, TJsonQueryOptionalKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../types/jsonQuery';
import { COMMON_PROPERTIES } from './constants';

export function getUncommonProperties(jsonQuery: IJsonQuery): NonEmptyArray<TJsonQueryOptionalKeys> | null {
  const jsonQueryKeys = Object.keys(jsonQuery) as TJsonQueryKeys[];
  const uncommonProperties = jsonQueryKeys.filter(filterUncommonProperties);

  return uncommonProperties.length > 0 ? (uncommonProperties as NonEmptyArray<TJsonQueryOptionalKeys>) : null;
}

function filterUncommonProperties(property: TJsonQueryKeys): property is TJsonQueryOptionalKeys {
  return !COMMON_PROPERTIES.includes(property);
}
